export default __webpack_public_path__ + "static/media/IMG_1426.71da5e31.jpg";